import { menuAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  menuAnatomy.keys,
);

const baseStyle = definePartsStyle({
  list: {
    bg: 'bg.elevated',
    color: 'text.primary',
    borderWidth: '1px',
    borderColor: 'border.muted',
    boxShadow: 'elevation.2',
    borderRadius: 'lg',
  },
  item: {
    _focusVisible: {
      bg: 'accent.default',
      color: 'accent.on',
    },
    _hover: {
      bg: 'bg.elevated',
    },
  },
  divider: {
    borderColor: 'border.muted',
  },
});

export const Menu = defineMultiStyleConfig({
  baseStyle,
});
